import { render, staticRenderFns } from "./QuantityAlert.vue?vue&type=template&id=58833c8e&scoped=true"
import script from "./QuantityAlert.vue?vue&type=script&lang=js"
export * from "./QuantityAlert.vue?vue&type=script&lang=js"
import style0 from "./QuantityAlert.vue?vue&type=style&index=0&id=58833c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58833c8e",
  null
  
)

export default component.exports